import { render, staticRenderFns } from "./TabStaffPackage.vue?vue&type=template&id=2edb5d9d"
import script from "./TabStaffPackage.vue?vue&type=script&lang=js"
export * from "./TabStaffPackage.vue?vue&type=script&lang=js"
import style0 from "./TabStaffPackage.vue?vue&type=style&index=0&id=2edb5d9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports